module.exports = __webpack_public_path__ + "img/stripe.dd7a1a37.png";